/**
 * The ChangePasswordError Code.
 */
export type FinalizeUserCreationErrorCode =
    | 'expiredToken'
    | 'passwordAndConfirmationPasswordDoesNotMatch'
    | 'passwordInsecure'
    | 'passwordContainsUserData'
    | 'unknown';

/**
 * Error thrown when the login is not performed successfully
 *
 * @export
 */
export class FinalizeUserCreationError implements Error {
    /** The Error Name */
    get name(): string {
        return 'FinalizeUserCreationError';
    }

    /** The Error Message */
    message: string;

    /** The Error Code */
    code: FinalizeUserCreationErrorCode;

    constructor(code: FinalizeUserCreationErrorCode, message: string) {
        this.message = message;
        this.code = code;
    }
}
